import { render, staticRenderFns } from "./textNumbers.pug?vue&type=template&id=efa55a9a&lang=pug&"
import script from "./textNumbers.js?vue&type=script&lang=js&"
export * from "./textNumbers.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efa55a9a')) {
      api.createRecord('efa55a9a', component.options)
    } else {
      api.reload('efa55a9a', component.options)
    }
    module.hot.accept("./textNumbers.pug?vue&type=template&id=efa55a9a&lang=pug&", function () {
      api.rerender('efa55a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/textNumbers/index.vue"
export default component.exports